import { render, staticRenderFns } from "./htmlPage.vue?vue&type=template&id=665f8a26&scoped=true&"
import script from "./htmlPage.vue?vue&type=script&lang=js&"
export * from "./htmlPage.vue?vue&type=script&lang=js&"
import style0 from "./htmlPage.vue?vue&type=style&index=0&id=665f8a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f8a26",
  null
  
)

export default component.exports